import React from 'react'
import { Loading, format, publish } from '../../twd'
import { PAGESIZE } from '../use-orders'

export const More =  ({rows, status, count, onLoadMore, pageSize=PAGESIZE} = {}) => {
    const moreCount = Math.min(pageSize, count - rows.length)

    return <Loading status={status}>
    { rows.length ? (
        <div className="row">
        <div className="col-xs-12 col-sm-3 text-bold">
        { moreCount > 0
            ? (<React.Fragment>1 - {format.count(rows.length)} of {format.count(count)}</React.Fragment>)
            : <React.Fragment>{format.count(count)}</React.Fragment>
        } {`Order${count>1 ? 's':''}`}</div>

        { moreCount > 0 ? (
            <div className="col-xs-12 col-sm-6">
                <button
                    data-name="offerings-view-more"
                    onClick={onLoadMore}
                    className="btn btn-primary btn-block"
                >View {format.count(moreCount)} more</button>
            </div>
        ) : null}
        </div>
    ) : (
        <div className="col-md-12 text-center">
        <i className="et-icon et-alert et-icon-md" aria-hidden="true"></i>
        <div className="small-header">There are no orders that match the dates and filters above</div>
        <p>Please select another date range and/or try different filters. 
            You can also <button 
                data-name="orders-reset-all-filters"
                className="btn-label link-button" 
                onClick={()=> { publish('orders_reset_filters', { isApply:true })}}
                >reset all filters</button>
        </p>
        </div>
    )}
    </Loading>
}



// WEBPACK FOOTER //
// ./src/orders/blotter/more.js